module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/injection/upload-file/upload-file.component.css
// module id = ./src/app/modules/injection/upload-file/upload-file.component.css
// module chunks = main